import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import cx from 'obj-str';
import { D as DimsumConfig, c as cssPipeline } from './classNameManager-f813320f.js';
import { isNativeHTMLElement, isValidNativeAttribute } from './validateNativeProps.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@elliemae/ds-utilities/utils';
import './converPropsToFormModifiers.js';
import './convertPropsToLayoutModifiers.js';
import './convertPropToFeedBackModifiers.js';
import './convertPropsToSizeModifiers.js';
import './convertPropsToTextModifiers.js';
import './convertPropsToColorModifiers.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var cssPrefix = DimsumConfig.classNamePrefix;

var generateClassNameWithModifier = function generateClassNameWithModifier(block, element, modifier) {
  return "".concat(cssPrefix, "-").concat(block).concat(element ? "__".concat(element) : '', "--").concat(modifier);
};

var appendBlockAndPrefixToObj = function appendBlockAndPrefixToObj(obj, block, element) {
  return obj ? Object.keys(obj).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, "".concat(generateClassNameWithModifier(block, element, key)), obj[key]));
  }, {}) : [];
};

function aggregatedClasses(type, props) {
  // aggregatedClasses options parameters
  return function (block, element, additionalModifiers) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return /*#__PURE__*/React.forwardRef(function (_ref, ref) {
      var innerRef = _ref.innerRef,
          children = _ref.children,
          classProps = _ref.classProps;
          _ref.useComponent;
          var className = _ref.className,
          as = _ref.as,
          rest = _objectWithoutProperties(_ref, ["innerRef", "children", "classProps", "useComponent", "className", "as"]);

      // get the additional classNames either from a function or an object
      var otherModifiers = appendBlockAndPrefixToObj(additionalModifiers, block, element);
      if (typeof additionalModifiers === 'function') otherModifiers = appendBlockAndPrefixToObj(additionalModifiers(_objectSpread(_objectSpread(_objectSpread({}, rest), classProps), {}, {
        className: className
      })), block, element);
      var otherModifiersStr = cx(otherModifiers);
      var prefix = options.prefix,
          _options$propsToRemov = options.propsToRemoveFromFinalElement,
          propsToRemoveFromFinalElement = _options$propsToRemov === void 0 ? [] : _options$propsToRemov;

      var _convertPropToCssClas = cssPipeline(block, null, _objectSpread({}, classProps), {
        prefix: prefix,
        element: element
      }),
          classNames = _convertPropToCssClas.cssClassName;

      var cleanedPropsPassedDown = _objectSpread(_objectSpread({}, props), rest);

      propsToRemoveFromFinalElement.forEach(function (propKey) {
        delete cleanedPropsPassedDown[propKey];
      });

      if (isNativeHTMLElement(block)) {
        Object.keys(cleanedPropsPassedDown).forEach(function (key) {
          if (!isValidNativeAttribute(key)) delete cleanedPropsPassedDown[key];
        });
      }

      return /*#__PURE__*/React.createElement(as || type, _objectSpread({
        ref: innerRef || ref,
        className: [classNames, otherModifiersStr, className].join(' ')
      }, cleanedPropsPassedDown), children);
    });
  };
}

export default aggregatedClasses;
export { cssPrefix };
//# sourceMappingURL=aggregatedClasses.js.map
